export const GET_TIME_REQUEST = 'GET_TIME_REQUEST';
export const GET_RUNNING_TIMER_REQUEST = 'GET_RUNNING_TIMER_REQUEST';
export const GET_RUNNING_TIMERS_REQUEST = 'GET_RUNNING_TIMERS_REQUEST';
export const GET_RUNNING_TIMER_BY_USER_REQUEST = 'GET_RUNNING_TIMER_BY_USER_REQUEST';
export const GET_TIME_RECORDS_BY_USER_REQUEST = 'GET_TIME_RECORDS_BY_USER_REQUEST';
export const GET_TIME_BY_USER_TOTAL_REQUEST = 'GET_TIME_BY_USER_TOTAL_REQUEST';
export const GET_TIME_PROFILE_REQUEST = 'GET_TIME_PROFILE_REQUEST';
export const GET_CLIENTS_WITH_RECENT_ACTIVITY_REQUEST = 'GET_CLIENTS_WITH_RECENT_ACTIVITY_REQUEST';
export const CREATE_TIME_REQUEST = 'CREATE_TIME_REQUEST';
export const UPDATE_TIME_REQUEST = 'UPDATE_TIME_REQUEST';
export const DELETE_TIME_REQUEST = 'DELETE_TIME_REQUEST';
export const RESTORE_TIME_REQUEST = 'RESTORE_TIME_REQUEST';

export const getRunningTimer = (callback) => ({
    type: GET_RUNNING_TIMER_REQUEST,
    payload: { callback }
});

export const getRunningTimers = (callback) => ({
    type: GET_RUNNING_TIMERS_REQUEST,
    payload: { callback }
});

export const getRunningTimerByUser = (userId, callback) => ({
    type: GET_RUNNING_TIMER_BY_USER_REQUEST,
    payload: { userId, callback }
});

export const getTimers = (parentType, parentId, callback) => ({
    type: GET_TIME_REQUEST,
    payload: { parentType, parentId, callback }
});

export const getTimeRecordsByUser = (userId, callback) => ({
    type: GET_TIME_RECORDS_BY_USER_REQUEST,
    payload: { userId, callback }
});

export const getTimeByUserTotal = (userId, callback) => ({
    type: GET_TIME_BY_USER_TOTAL_REQUEST,
    payload: { userId, callback }
});

export const getTimeProfile = (userId, callback) => ({
    type: GET_TIME_PROFILE_REQUEST,
    payload: { userId, callback }
});

export const postTime = (parentType, parentId, data, callback) => ({
    type: CREATE_TIME_REQUEST,
    payload: { parentType, parentId, data, callback },
});

export const startTimer = (parentType, parentId, data, callback) => {
    const timerData = { ...data, time: 0 };
    return {
        type: CREATE_TIME_REQUEST,
        payload: { parentType, parentId, data: timerData, callback },
    };
};

export const updateTime = (timeId, data, callback) => ({
    type: UPDATE_TIME_REQUEST,
    payload: { timeId, data, callback },
});

export const stopTimer = (timeId, data, callback) => {
    const timerData = { ...data, time: 0 };
    return {
        type: UPDATE_TIME_REQUEST,
        payload: { timeId, data: timerData, callback },
    };
};

export const deleteTime = (timeId, callback) => ({
    type: DELETE_TIME_REQUEST,
    payload: { timeId, callback },
});

export const restoreTime = (timeId, callback) => ({
    type: RESTORE_TIME_REQUEST,
    payload: { timeId, callback },
});

export const getClientsWithRecentActivity = (callback) => ({
    type: GET_CLIENTS_WITH_RECENT_ACTIVITY_REQUEST,
    payload: { callback },
});
